import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  subject: Subject<boolean> = new Subject();
  constructor(private datePipe: DatePipe) { }
  ConvertDateToString(date) : string {
    var datePipe = new DatePipe("en-US");
    let dateAsString : string= datePipe.transform(date,"MM/dd/yyyy" );
    // date.setTime(date.getTime()+date.getTimezoneOffset()*60*1000);
    // console.log(date); // Gives Tue Mar 22 2016 04:00:00 GMT+0530 (IST)
  
    // var offset = -300; //Timezone offset for EST in minutes.
    // var estDate = new Date(date.getTime() + offset*60*1000);
  
  
   //console.log('fomttttt' ,estDate);
   return  dateAsString ;
  }
  getUtcDate(date): string | null {
    if (!date) return null;
  
    const utcDate = new Date(date);
    if (isNaN(utcDate.getTime())) return null; 
  
    return utcDate.toUTCString();
  }
  
  convertToUtc(localDate: Date): Date {
    //
    //   const  newDateTimezone  = new Date().getTimezoneOffset(); // your timezone
    //   var ccc= new Date(date)
    //   date = this.addMinutes(ccc,newDateTimezone);
    // return date;
    if (localDate && (localDate instanceof Date)) {
      var timezoneOffsetMinutes = this.getTimezoneOffsetMinutesForCurrentClient();
      localDate = this.addMinutes(localDate, timezoneOffsetMinutes);
    }
    else {
      throw "Input variable must be Date";
    }
    return localDate;
  }
  convertFromUtc(date: Date): Date {
    //
    //   const  newDateTimezone  = new Date().getTimezoneOffset(); // your timezone
    //   var ccc= new Date(date)
    //   date = this.addMinutes(ccc,newDateTimezone);
    // return date;
    if (date && (date instanceof Date)) {
      var timezoneOffsetMinutes = date.getTimezoneOffset();
      var setMinutes = date.getMinutes() - timezoneOffsetMinutes;
      date.setMinutes(setMinutes);
    }
    else {
      throw "Input variable must be Date";
    }
    return date;
  }
  addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
  }
  convertFromUtc2(date: Date): Date {

    //   const  newDateTimezone  = new Date().getTimezoneOffset(); // your timezone
    //   var ccc= new Date(date)
    //   date = this.addMinutes(ccc,newDateTimezone);
    // return date;
    let date1 = new Date(date);
    var timezoneOffsetMinutes = new Date().getTimezoneOffset();
    var setHours = date1.getHours() + (timezoneOffsetMinutes / 60);
    date1.setHours(setHours);

    return date1;
  }
  getTimezoneOffsetMinutesForCurrentClient() {
    let date = new Date();
    return date.getTimezoneOffset();
  }
  getTimezoneOffsetHoursForCurrentClient() {
    return this.getTimezoneOffsetMinutesForCurrentClient() / 60;
  }
    getTimezoneOffsetHoursForCurrentClientToAddedLaterFromServer() {
    return this.getTimezoneOffsetHoursForCurrentClient()*-1;
  }
}
